import { useEffect, useCallback } from 'react';
import usePromiseModalState from '@sdk/components/ui/modal/usePromiseModalState';

import KeepAccountModal from '@web/account/KeepAccountModal/KeepAccountModal';

const KeepAccountModalAngular = ({ shown, onClose, transferOwnershipMode, isPremium }) => {
  const keepAccountModalState = usePromiseModalState();

  const open = useCallback(async () => {
    const result = await keepAccountModalState.getResult();
    onClose(result);
  }, [onClose, keepAccountModalState]);

  useEffect(() => {
    if (shown) {
      open();
    }
  }, [shown]); // eslint-disable-line

  return (
    <KeepAccountModal
      {...keepAccountModalState}
      transferOwnershipMode={transferOwnershipMode}
      isPremium={isPremium}
    />
  );
};

export default {
  ReactComponent: KeepAccountModalAngular,
  bindings: {
    shown: '<',
    onClose: '<',
    transferOwnershipMode: '<?',
    isPremium: '<',
  },
};
